import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { MemberSpotlightContentModel } from 'src/api/models/MemberSpotlight';
import {
  MemberSpotlightAvatar,
  MemberSpotlightContainer,
  MemberSpotlightTextWrapper,
} from 'src/molecules/Standard/Shared/MemberSpotlight/MemberSpotlight.styles';
import Paragraph from 'elements/typography/paragraph';
import Heading from 'elements/typography/heading';
import { palette } from 'styles/colors';

const MemberSpotlight = ({ memberAvatar, memberName, memberQuote }: MemberSpotlightContentModel): JSX.Element => (
  <MemberSpotlightContainer>
    <MemberSpotlightAvatar>
      <GatsbyImage
        alt={memberName}
        image={memberAvatar.gatsbyImageData}
      />
    </MemberSpotlightAvatar>
    <MemberSpotlightTextWrapper>
      <Paragraph
        textTransform='uppercase'
        weight={600}
        standardSize='1.125'
        color={palette.greyText}
        align='left'
        text='Member Spotlight'
      />
      <Heading
        standardSize='2.125'
        align='left'
        text={memberName}
      />
      <Paragraph
        standardSize='1'
        lineHeight='1.5'
        weight={300}
        align='left'
        text={memberQuote.memberQuote}
      />
    </MemberSpotlightTextWrapper>
  </MemberSpotlightContainer>
);

export default MemberSpotlight;
